// extracted by mini-css-extract-plugin
export default {"wrapper":"UserRatedCompaniesPage_wrapper__Qebq5"};